if(!customElements.get('myth-toggle')) {
  class ComponentMythToggle extends HTMLElement {
    constructor() {
      super();

      this.active = false;
      this.front = this.querySelector(".myth-front");
      this.toggleCircle = this.querySelector(".toggle-circle");
      this.button = this.querySelector(".btn");
      this.backTitle = this.querySelector(".back-text .title");
      this.backSubtitle = this.querySelector(".back-text .subtitle");
      this.circleText = this.querySelector(".circle-text");
      this.frontText = this.querySelector(".front-text");
      this.liveRegion = this.querySelector("[id^='myth-live-']");
      this.activableElements = [ this.button, this.front, this.toggleCircle];

      this.button.addEventListener('click', () => {
        this.active = !this.active;
        if(this.active){
          this.activableElements.forEach(element =>{
            element.classList.add("active");
            element.parentElement.classList.add("active");
          })
        }
        else{
          this.activableElements.forEach(element =>{
            element.classList.remove("active");
            element.parentElement.classList.remove("active");
          })
        }
        this.updateAccessibility(true);
      })

      this.updateAccessibility(false);
    }

    getText(node) {
      return node && node.textContent ? node.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    getCollapsedLabel() {
      return [
        this.getText(this.backTitle),
        this.getText(this.backSubtitle),
        this.getText(this.circleText),
        'Expand'
      ].filter(Boolean).join(', ');
    }

    getExpandedLabel() {
      return [
        this.getText(this.frontText),
        'Collapse'
      ].filter(Boolean).join(', ');
    }

    getExpandAnnouncement() {
      var front = this.getText(this.frontText);
      return front ? front + '. Collapse button.' : 'Collapse button.';
    }

    getCollapseAnnouncement() {
      var summary = [
        this.getText(this.backTitle),
        this.getText(this.backSubtitle),
        this.getText(this.circleText)
      ].filter(Boolean).join(', ');
      return summary ? summary + '. Expand button.' : 'Expand button.';
    }

    updateAccessibility(announce) {
      if (!this.button) return;

      this.button.setAttribute('aria-expanded', this.active ? 'true' : 'false');
      this.button.setAttribute(
        'aria-label',
        this.active ? this.getExpandedLabel() : this.getCollapsedLabel()
      );

      if (this.front) {
        this.front.setAttribute('aria-hidden', this.active ? 'false' : 'true');
      }

      if (this.liveRegion && announce) {
        this.liveRegion.textContent = this.active
          ? this.getExpandAnnouncement()
          : this.getCollapseAnnouncement();
        window.setTimeout(() => {
          if (this.liveRegion) this.liveRegion.textContent = '';
        }, 1500);
      }
    }
  }
  customElements.define('myth-toggle', ComponentMythToggle);
}
